export const anchorStyles = ({ x, y }, triggerRef) => {
    const xStyle = { [x]: 0 };
    const yStyle = { [y === 'top' ? 'bottom' : 'top']: triggerRef.current?.offsetHeight };

    return { ...xStyle, ...yStyle };
};
